<template>
  <div id="app">
    <loading :isShow="showOrNot" @nextPage="onNextPage" />
    <page-kv
      :isShow="showOrNot"
      @nextPage="onNextPage"
      @playMusic="onPlayMusic"
    />
    <page-one
      :isShow="showOrNot"
      @nextPage="onNextPage"
      @sendName="onSendName"
    />
    <page-two
      :isShow="showOrNot"
      @nextPage="onNextPage"
      @sdList="handleSdList"
      @playMusic="onPlayMusic"
    />
    <page-three :sendList="myList" :isShow="showOrNot" @nextPage="onNextPage" />
    <page-four
      :name="nickname"
      :ava="avaUrl"
      :sendList="myList"
      :isShow="showOrNot"
      @nextPage="onNextPage"
    />
    <music-player :isShow="showOrNot" />
    <wx-share
      :shareTitle="title"
      :shareDesc="desc"
      :shareImg="thumbImg"
      :shareLink="link"
    />
    <div class="audio-wp">
      <audio :src="m1" id="m1" preload="preload"></audio>
      <audio :src="m2" id="m2" preload="preload"></audio>
    </div>
    <rotate-it />
  </div>
</template>

<script>
import Rotate from './components/rotate/Rotate'
import MusicPlayer from './components/musicplayer/music-player'
import Loading from './pages/loading/loading'
import PageKV from './pages/page-kv/pageKV'
import PageOne from './pages/page-one/pageOne'
import PageTwo from './pages/page-two/pageTwo'
import PageThree from './pages/page-three/pageThree'
import PageFour from './pages/page-four/pageFour'
import WxShare from './components/wxShare/wxShare'
import { postData } from './assets/util'

export default {
  name: 'app',
  components: {
    Loading,
    'rotate-it': Rotate,
    'music-player': MusicPlayer,
    'page-one': PageOne,
    'page-two': PageTwo,
    'page-kv': PageKV,
    'wx-share': WxShare,
    'page-three': PageThree,
    'page-four': PageFour,
  },
  data() {
    return {
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false,
        isPHShow: false,
        isPFShow: false,
      },
      title: '文明昌江人必做的100件事',
      desc: '一起为昌江创文添彩，共建"山海黎乡大花园"！',
      thumbImg:
        'https://www.jiandoukeji.com/h5/2020/changjiang100/common/thumb.jpg',
      link: '',
      myList: [],
      avaUrl: '',
      nickname: '',
      m1: require('./pages/page-one/slide.mp3'),
      m2: require('./pages/page-one/select.mp3'),
    }
  },
  mounted() {
    this.request()
    this.autoPlay()
  },
  methods: {
    onPlayMusic(para) {
      let audio = document.getElementById(para)
      audio.play()
      document.addEventListener(
        'WeixinJSBridgeReady',
        function () {
          audio.play()
        },
        false
      )
    },
    autoPlay() {
      const data = [1, 2]
      data.map((item) => {
        let audio = document.querySelector(`#m${item}`)
        audio.volume = 0.1
        audio.play()
        document.addEventListener(
          'WeixinJSBridgeReady',
          function () {
            audio.play()
          },
          false
        )
        setTimeout(() => {
          audio.pause()
          document.addEventListener(
            'WeixinJSBridgeReady',
            function () {
              audio.pause()
            },
            false
          )
          audio.volume = 1
        }, 20)
      })
    },
    onSendName(para) {
      this.nickname = para
    },
    onNextPage(para) {
      Object.keys(this.showOrNot).map((item) => {
        this.showOrNot[item] = false
      })
      this.showOrNot[para] = true
    },
    handleSdList(para) {
      this.myList = para
    },
    async request() {
      const URL = '/codes/2020/changjiang/game.php/Home/Index/JDOU_whoyouare'
      const authURL =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx56c4ff994dee2c86&redirect_uri=http%3a%2f%2fwww.jiandoukeji.com%2fcodes%2f2020%2fchangjiang%2fgame.php%2fHome%2fWxwx%2f&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirec'
      const saveURL = '/codes/jiandou/game.php/Home/Share2/wxPicSave/'
      try {
        const authed = await postData(URL)
        if (authed.status === 1) {
          const saveData = await postData(saveURL, { url: authed.avator })
          if (saveData.status === 1) {
            this.avaUrl = saveData.data.url
          } else {
            console.log('上传图片失败')
          }
        } else {
          window.location.href = authURL
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style>
@import './assets/reset.less';
#app {
  width: 100%;
  height: 100%;
  min-width: 320px;
  max-width: 540px;
  -webkit-user-select: none;
  user-select: none;
}
canvas {
  width: 100%;
}
</style>
